<template>
  <div class="header">
    <div class="flex">
      <div class="text_title flex">
        <img v-if="currentId === 4" src="@/assets/img/index/yxzt.png" alt="" />
        <img v-else src="@/assets/img/index/text_title.png" alt="" />
      </div>
      <div class="nav_top">
        <router-link to="/">
          <div class="item" :class="{ active: currentId === 1 }" @click="changeNav(1)">首页</div>
        </router-link>
        <router-link to="/digitalBooks">
          <div class="item" :class="{ active: currentId === 2 }" @click="changeNav(2)">古籍文献资源库</div>
        </router-link>
        <router-link to="/medicineBooks">
          <div class="item" :class="{ active: currentId === 4 }" @click="changeNav(4)">医学专题资源库</div>
        </router-link>
        <router-link to="/about">
          <div class="item" :class="{ active: currentId === 3 }" @click="changeNav(3)">关于我们</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentId: 1
    }
  },
  props: {
    num: {
      type: Number
    }
  },
  mounted() {
    //切换top nav 高亮
    if (this.$route.name === 'home') {
      this.currentId = 1
    } else if (this.$route.name === 'digitalBooks') {
      this.currentId = 2
    } else if (this.$route.name === 'medicineBooks') {
      this.currentId = 4
    } else {
      this.currentId = 3
    }
  },
  methods: {
    changeNav(num) {
      console.log('num', num)

      this.currentId = num
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: relative;
  top: 37px;
}
.nav {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  .item {
    width: 120px;
    height: 40px;
    background: #f5f0ea;
    border-radius: 0px 0px 8px 8px;
    letter-spacing: 2px;
    font-size: 18px;
    color: #333;
    margin: 0 20px;
  }
  .active {
    background: @theme;
    color: #fff;
  }
}
.logo {
  position: absolute;
  top: 10px;
  right: 0;
}
.text_title {
  padding-top: 120px;
  margin-bottom: 40px;
}
.nav_top {
  position: absolute;
  top: 36px;
  left: 0;
  width: 255px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  .item {
    width: 150px;
    height: 47px;
    text-align: center;
    line-height: 47px;
    font-size: 18px;
    font-weight: 400;
    color: #333;
    letter-spacing: 3px;
    background: #fff;
    border: none;
    border-radius: 8px;
    margin-right: 20px;
  }
  .active {
    background-color: #e77d0f;
    color: #fff;
  }
}
</style>
